<template>
    <div>
        <ui-checkbox-input
            v-model="selected"
            class="custom-control custom-checkbox stores-list-checkbox "
            :name="`${checkboxName}-${rowId}`"
            :disabled="amIDisabled"
        />
    </div>
</template>

<script>
import UiCheckboxInput from '../UiCheckboxInput.vue'

export default{
    components: {
        UiCheckboxInput
    },
    props: {
        itemsGetterName: {
            type: String,
            default: ''
        },
        checkboxName: {
            type: String,
            default: ''
        },
        row: {
            type: Array,
            default: () => []
        },
        rowId: {
            type: Number,
            default: 0
        },
        onChange: {
            type: Function,
            default: () => {}
        },
        checked: {
            type: Boolean,
            default: undefined
        }

    },
    computed: {
        amIDisabled() {
            return this.row.find(r => r.type === 'hidden') && this.row.find(r => r.type === 'hidden').data.disabled
        },
        amISelected() {
            if(this.checked !== undefined) return this.checked
            const checkedItems = this.$store.getters[this.itemsGetterName] && this.$store.getters[this.itemsGetterName].filter(store => store.checked)
            if(!checkedItems || checkedItems.length < 1) return false
            const checkedIds = checkedItems.map(item => item.id)

            const currentItemId = this.row.find(r => r.type === 'hidden').data.id
            if(checkedIds.indexOf(currentItemId) > -1) return true

            return false
        }
    },
    watch: {
        amISelected: {
            immediate: true,
            handler(val) {
                if(val === this.selected) return
                if(this.row.find(r => r.type === 'hidden').data.disabled) return
                this.selected = val
            }
        },
        selected (val) {
            this.onChange(val)
        }
    },
    data() {
        return{
            selected: false
        }
    }
}
</script>
<style lang="scss">
.stores-list-checkbox{
    width: 1.7rem;
    height: 1.7rem;
    .custom-control-label::after,
    .custom-control-label::before {
        top:0.1rem;
        left:-1.4rem;
        width: 1.5rem;
        height: 1.5rem;
    }}
</style>